import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 25px',
    backgroundColor: theme.palette.whitePepper.main,
    [theme.breakpoints.up('sm')]: {
      padding: '35px 50px 50px',
    },
  },

  container: {
    flexGrow: 1,
    maxWidth: '1050px',
  },

  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },

  orderedlist: {
    padding: 0,
    marginLeft: '25px',
    //listStylePosition: 'inside',
  },

  listItem: {
    '&::marker': {
      fontSize: '22px',
      lineHeight: '28px',
      color: theme.palette.cinnamon.main,
    },
  },

  unorderedlist: {
    margin: '0 0 8px',
  },

  unorderedlistItem: {
    '&::marker': {
      color: theme.palette.cinnamon.main,
    },
  },
});
